import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'svg[mai-404]',
  templateUrl: './ai-404.html',
  host: {
    '[attr.viewBox]': 'viewbox()',
    class: 'h-24 fill-current transition-colors',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Ai404Svg {
  readonly viewbox = input<string>('0 0 22 20');
}
